module.exports = __webpack_public_path__ + "img/schuber.8e52b772.png";